import { useStore } from '@nanostores/react';
import { $progressStore, progressActions, type PlayerProgress } from '@/stores/progressStore';

export function useProgress() {
  const progress = useStore($progressStore);

  return {
    // Состояние
    ...progress,
    
    // Действия
    setCurrentStep: progressActions.setCurrentStep,
    setCurrentYaml: progressActions.setCurrentYaml,
    nextStep: progressActions.nextStep,
    prevStep: progressActions.prevStep,
    resetProgress: progressActions.resetProgress,
    updateProgress: progressActions.updateProgress,
    
    // Новые действия с API
    loadTaskByStep: progressActions.loadTaskByStep,
    loadCurrentTask: progressActions.loadCurrentTask,
    nextStepWithTask: progressActions.nextStepWithTask,
    submitSolution: progressActions.submitSolution,
    clearValidationResult: progressActions.clearValidationResult,
    initializeProgress: progressActions.initializeProgress,
    
    // Вспомогательные функции
    isFirstStep: progress.currentStep === 1,
    hasYaml: progress.currentYaml !== null,
    hasTask: progress.currentTask !== null,
    hasError: progress.error !== null,
    
    // Полный объект прогресса
    progress,
  };
}